// Fixed, non-linear set of selectable durations - the slider works purely
// over this array's INDEX (0..length-1), never over the minute value
// itself, which is what makes every stop equidistant on the track while
// the actual time values are non-linear (5..360). Persisted per report
// item via dailyReportItemCodec (JSON content field).
export const ESTIMATED_TIME_STOPS = [5, 10, 15, 20, 30, 45, 60, 90, 120, 150, 180, 240, 300, 360];
export const DEFAULT_ESTIMATED_TIME = 30;

export function formatEstimatedMinutes(min) {
  if (min < 60) return `${min} دقیقه`;
  const hours = min / 60;
  return Number.isInteger(hours) ? `${hours} ساعت` : `${Math.floor(hours)} ساعت و ${min % 60} دقیقه`;
}

// Reusable range slider snapped to ESTIMATED_TIME_STOPS. `value` is a
// minute value (must be one of the stops); `onChange` is called with the
// new minute value, not the raw slider index - callers never need to know
// this is index-based internally.
export default function EstimatedTimeSlider({ value = DEFAULT_ESTIMATED_TIME, onChange, label = 'زمان تخمینی', style: extra }) {
  const index = Math.max(0, ESTIMATED_TIME_STOPS.indexOf(value));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...extra }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: '#64748b' }}>{label}</span>
        <span style={{ fontSize: 12, fontWeight: 700, color: '#233A7A', background: '#EDF3FC', padding: '2px 10px', borderRadius: 10 }}>
          {formatEstimatedMinutes(ESTIMATED_TIME_STOPS[index])}
        </span>
      </div>
      <input
        type="range"
        min={0}
        max={ESTIMATED_TIME_STOPS.length - 1}
        step={1}
        value={index}
        // A plain <input type="range"> with integer index steps IS the
        // snap-to-nearest-stop behavior - there's no fractional position to
        // round, the browser only ever lands on a whole index while
        // dragging.
        onChange={(e) => onChange?.(ESTIMATED_TIME_STOPS[Number(e.target.value)])}
        style={{ width: '100%', accentColor: '#29AAE1', cursor: 'pointer' }}
      />
    </div>
  );
}
